module.exports = __webpack_public_path__ + "img/197.blockage_toilet.3dbb0073.svg";